import './assets/Button.css';const t = "_button_7w21h_4", n = "_large_7w21h_37", o = "_fullWidth_7w21h_43", _ = "_hasIconLeft_7w21h_48", e = "_hasIconRight_7w21h_52", c = "_iconOnly_7w21h_64", i = "_iconDefault_7w21h_74", s = "_iconLarge_7w21h_79", h = "_inverted_7w21h_141", l = "_destructive_7w21h_148", a = "_outline_7w21h_159", u = {
  button: t,
  large: n,
  fullWidth: o,
  hasIconLeft: _,
  hasIconRight: e,
  iconOnly: c,
  iconDefault: i,
  iconLarge: s,
  inverted: h,
  destructive: l,
  outline: a,
  "outline-variant": "_outline-variant_7w21h_164"
};
export {
  u as s
};
